import actionTypes from 'src/modules/redux/actionTypes'

export const setRouter = url => ({
  type: actionTypes.SET_ROUTER,
  payload: url
})
